// THIS REALLY NEEDS TO BE FIXED PROPERLY
// FUTURE: convert this into a reusabel component instead of a mixin
import hash from "object-hash";
import lStore from "./lStore";
import moment from "moment-timezone";
import { mapGetters } from "vuex";

export default {
  // Once converted to component
  // props: {
  //   cols: {
  //     type: Object
  //   },
  //   selectedCols: {
  //     type: Array
  //   },
  //   perPage: {
  //     type: Number,
  //     default: 25
  //   }
  // },
  mounted() {
    this.getMarketPlaces();
    // this.getUserPrintedBy()
  },
  data() {
    return {
      customRange: "",
      selected_text: "Records Selected",
      selection_class: "vgtSelectInfo",
      isLoading: false,
      // value could be 3 for shipped,4 for voided,5 for returns
      orderType: {
        id: 3,
        name: "shipped",
      },

      // for modal
      shown: null,
      shownObjs: {},

      selectedColumns: [
        // "marketplace", "status", "created_at", "name", "tracking_id", "shipping_service",
        // "package_type", "total_weight", "total_price", "postmark_date",
        "marketplace",
        "printed_by",
        "status",
        "origin_address",
        "origin_postal",
        "order_number",
        "ref_id",
        "created_at",
        "name",
        "address",
        "tracking_id",
        "shipping_service",
        "package_type",
        "total_weight",
        "declared_value",
        "insurance_price",
        "rate",
        "total_price",
        "surcharge",
        "confirmation",
        "dimension",
        "tracking_price",
        "prepaid_return",
        "product_sku",
        "label_sticky",
        "label_sticky_2",
        "email",
        "phone",
        "postmark_date",
        "description",
        "acct_id",
        "delivery_zone",
        "extra_1",
        "extra_2",
        "extra_3",
        "extra_4",
        "extra_5",
      ],
      selected: [],
      searchkw: "",
      searchTerm: "",
      serverParams: {
        columns: null,
        printed_by: "all",
        returned_by: "all",
        voided_by: "all",
        marketType: "all",
        dateRange: null,
        searchTerm: "",
        ids: [],
        columnFilters: null,
        sort: null,
        page: 1,
        perPage: 50,
      },
      marketplaceOptions: [],
      userOptions: [],
      totalRecords: 0,
      rows: [],
      columns: [
        {
          field: "id",
          label: "Actions",
          thClass: "vgt-headers narrower",
          sortable: false,
        },
        {
          field: "marketplace",
          label: "Marketplace",
          thClass: "vgt-headers narrowest",
        },
        {
          field: "printed_by",
          label: "User",
          thClass: "vgt-headers narrower",
        },
        {
          field: "status",
          label: "Status",
          thClass: "vgt-headers narrower",
        },
        {
          field: "origin_address",
          label: "Origin Address",
          thClass: "vgt-headers wider",
        },
        {
          field: "origin_postal",
          label: "Origin Postal",
          thClass: "vgt-headers narrow",
        },
        {
          field: "order_number",
          label: "Order Number",
          sortable: true,
          thClass: "vgt-headers narrow",
        },
        {
          field: "ref_id",
          label: "Reference ID",
          sortable: false,
          thClass: "vgt-headers narrow",
        },
        {
          field: "created_at",
          label: "Printed Date",
          thClass: "vgt-headers wide",
        },
        // {
        //   field: 'shipped_at', label: "Shipment Date",
        //   thClass:"vgt-headers wide",
        // },
        {
          field: "name",
          label: "Recipient",
          thClass: "vgt-headers",
        },
        {
          field: "address",
          label: "Address",
          thClass: "vgt-headers widest",
        },
        {
          field: "tracking_id",
          label: "Tracking Number",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: "shipping_service",
          label: "Service Class",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: "package_type",
          label: "Package Type",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: "total_weight",
          label: "Weight",
          sortable: false,
          thClass: "vgt-headers narrower",
        },
        {
          field: "declared_value",
          label: "Declared Value",
          sortable: false,
          thClass: "vgt-headers narrow",
        },
        {
          field: "insurance_price",
          label: "Insurance",
          sortable: false,
          thClass: "vgt-headers narrow",
        },
        {
          field: "rate",
          label: "Shipping Rate",
          sortable: false,
          thClass: "vgt-headers narrower",
        },
        {
          field: "surcharge",
          label: "Surcharge",
          sortable: false,
          thClass: "vgt-headers narrower",
        },
        {
          field: "tracking_price",
          label: "Additional Tracking",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: "total_price",
          label: "Total Cost",
          sortable: false,
          thClass: "vgt-headers narrow",
        },
        {
          field: "confirmation",
          label: "Signature",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        {
          field: "dimension",
          label: "Dimensions",
          sortable: false,
          thClass: "vgt-headers narrower",
        },
        {
          field: "prepaid_return",
          label: "Prepaid Return",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "product_sku",
          label: "Product SKU",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "label_sticky",
          label: "Custom Field 1",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "label_sticky_2",
          label: "Custom Field 2",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "email",
          label: "Email",
          thClass: "vgt-headers",
        },
        {
          field: "phone",
          label: "Phone",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: "postmark_date",
          label: "Postmark Date",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: "description",
          label: "Description",
          sortable: true,
          thClass: "vgt-headers widest",
        },
        {
          field: "acct_id",
          label: "Account ID",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "delivery_zone",
          label: "Delivery Zone",
          sortable: true,
          thClass: "vgt-headers narrow",
        },
        {
          field: "extra_1",
          label: "Note 1",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "extra_2",
          label: "Note 2",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "extra_3",
          label: "Note 3",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "extra_4",
          label: "Note 4",
          sortable: true,
          thClass: "vgt-headers",
        },
        {
          field: "extra_5",
          label: "Note 5",
          sortable: true,
          thClass: "vgt-headers",
        },
      ],
    };
  }, // end of data
  watch: {
    searchkw: function (newVal, oldVal) {
      if (!newVal || !newVal.length) {
        this.onVGTClearSearch();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee_name: "getEmployeeName",
    }),
    columnSelection() {
      return this.columns.map((v) => {
        const { field, label } = v;
        if (v.field !== "id") return { field, label };
      }).filter((v) => !!v);
    },
    datePresetRanges() {
      return {
        all: () => {
          const n = new Date();
          const start = new Date(2018, 1, 1, 0, 0);
          const endToday = new Date(
            n.getFullYear(),
            n.getMonth(),
            n.getDate() + 1,
            23,
            59,
          );
          return {
            label: "All",
            active: true,
            dateRange: {
              start: start,
              end: endToday,
            },
          };
        },
        last7days: function () {
          const n = new Date();
          const start = new Date(
            n.getFullYear(),
            n.getMonth(),
            n.getDate() - 5,
          );
          const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
          return {
            label: "Last 7 Days",
            active: false,
            dateRange: {
              start: start,
              end: end,
            },
          };
        },
        last30days: function () {
          const n = new Date();
          const start = new Date(
            n.getFullYear(),
            n.getMonth(),
            n.getDate() - 29,
          );
          const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
          return {
            label: "Last 30 Days",
            active: false,
            dateRange: {
              start: start,
              end: end,
            },
          };
        },
        last12months: function () {
          const n = new Date();
          const start = new Date(
            n.getFullYear() - 1,
            n.getMonth(),
            n.getDate(),
          );
          const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
          return {
            label: "Last 12 Months",
            active: false,
            dateRange: {
              start: start,
              end: end,
            },
          };
        },
      };
    }, // date end of presets
  }, // end of computed

  methods: {
    // VGT EVENTS
    updateVGTParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onVGTDoubleClick(params) {
      console.log("double click params", params);
      this.showOrder(params.row.id);
    },
    onVGTSelected(params) {
      console.log("on select", params);
      if (params.selectedRows.length > 0) {
        const ids = params.selectedRows.map((v) => v.id);
        this.updateVGTParams({ ids });

        // let total = params.selectedRows.map(v => v.total_price).reduce((a, b) => parseFloat(a) + parseFloat(b))
        // if (total > this.balance) {
        //   this.selection_class = 'vgtSelectInfoDanger';
        //   this.disablePrint = true;
        // } else {
        //   this.selection_class = 'vgtSelectInfo';
        //   this.disablePrint = false;
        // }
        // this.selected_text = `Records Selected (Total Cost: ${this.format.price(total)})`;
      } else {
        this.updateVGTParams({ ids: [] });
      }
    },
    // all about search
    onVGTSearch(params) {
      console.log("on search", params);
      this.updateVGTParams({ searchTerm: params.searchTerm });
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTClearSearch() {
      this.searchkw = "";
      this.searchTerm = "";
    },
    async onTableSearch() {
      this.searchTerm = this.searchkw;
    },
    // end of all about search

    onVGTPageChange(params) {
      console.log("on pagination", params);
      this.updateVGTParams({ page: params.currentPage });
      this.fetchOrders();
    },
    onVGTPerPageChange(params) {
      console.log("on per page change", params);
      this.updateVGTParams({ perPage: params.currentPerPage });
      lStore.set(`${this.orderType.name}PerPage`, params.currentPerPage);
      // needs to clear everything since since the number of pages is already invalid
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTSortChange(params) {
      console.log("on sort change", params);
      if (!params.length) return;
      const { field, type } = params[0];
      this.updateVGTParams({ sort: [field, type] });
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTColumnFilter(params) {
      console.log("on columnfilter", params);
      this.updateVGTParams(params);
      this.fetchOrders();
    },
    onVGTColumnSelect() {
      console.log("on selectColumns", this.selectedColumns);
      this.columns = this.columns.map((column) => {
        if (column.field !== "id") {
          column.hidden = this.selectedColumns.includes(column.field)
            ? false
            : true;
        }
        return column;
      });
      this.updateVGTParams({ columns: this.selectedColumns });
      const cols = Object.assign({}, {
        columns: this.columns,
        selectedColumns: this.selectedColumns,
      });
      lStore.set(`${this.orderType.name}Columns`, cols);
    },
    onVGTDateRangeSelected(params) {
      let { end, start } = params;
      const tz = moment.tz.guess();

      if (!start) return;
      console.log("now", new Date(), moment().format());
      console.log("raw date", params);

      // TODO: picker keeps adding 1 day so just subtract 1 day (hack)
      // start = moment(start).subtract(1, 'day');
      start = moment(start).subtract(1, "day").startOf("day");
      if (!end) {
        end = start.clone().endOf("day");
      } else {
        end = moment(end).subtract(1, "day").endOf("day");
      }

      const s = start.utc().format();
      const e = end.utc().format();

      console.log("on date start in utc", s);
      console.log("on date end in utc", e);

      this.updateVGTParams({ dateRange: [s, e] });
      // this.updateVGTParams({ dateRange: [start,end]});
      // this.updateVGTParams(params);
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTMarketplaceChange() {
      console.log("on marketplace change", this.serverParams.marketType);
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTPrintedByChange() {
      console.log("on printed_by change", this.serverParams.printed_by);
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTReturnedByChange() {
      console.log("on returned_by change", this.serverParams.returned_by);
      this.clearSessionAndFetch(this.orderType.name);
    },
    onVGTVoidedByChange() {
      console.log("on voided_by change", this.serverParams.voided_by);
      this.clearSessionAndFetch(this.orderType.name);
    }, // VGT EVENTS

    // DATA
    async sync() {
      this.isLoading = true;
      let url = "/sync";
      switch (this.orderType.id) {
        case 4:
          url = "/sync/voided";
          break;
        case 5:
          url = "/sync/return";
          break;
      }
      const response = await axios.get(url);
      console.log("sync response", response);
      await this.clearSessionAndFetch(this.orderType.name);
    },
    async fetchOrders(page_url = `/orders-vgt`) {
      try {
        const tz = moment.tz.guess();
        console.log("TZ", tz);
        this.isLoading = true;
        const isExisting = await this.getFromSession(
          this.serverParams.page,
          this.orderType.name,
        );
        // if in session no need to call server
        if (isExisting) {
          console.log("existing", isExisting);
          this.rows = isExisting;
          return;
        }
        // const [userOptions, response] = await Promise.all([
        //   axios.get('/orders-users', {params: {status: this.orderType.id}}),
        //   axios.get(`${page_url}`,{
        //     params: Object.assign({}, {status: this.orderType.id, with_type: this.orderType.name, tz}, this.serverParams)
        //   })
        // ])
        // this.userOptions = [ { value: "all", text: "All" }, ...userOptions.data ];

        const response = await axios.get(`${page_url}`, {
          params: Object.assign({}, {
            status: this.orderType.id,
            with_type: this.orderType.name,
            tz,
          }, this.serverParams),
        });

        const { data: { data, total } } = response;
        console.log(data, total);
        this.totalRecords = total;
        this.rows = data.map((order) => {
          return this.mapToRows(order, this.orderType.id);
        });
        this.saveToSession(
          this.serverParams.page,
          this.rows,
          this.orderType.name,
        );
        // console.log('rows', this.rows);
        // console.log("ORDERS: ", this.orders);
      } catch (e) {
        console.error("error fetching orders", e);
      } finally {
        this.isLoading = false;
      }
    }, // get data from server

    mapToRows: function (order) {
      const pkgtypes = {
        PKG: "Package",
        IRRPKG: "Irregular Package",
        SOFTPACK: "Cubic Soft Pack",
        FRE: "Flat Rate Envelope",
        SFRB: "Small Flat Rate Box",
        FRB: "Medium Flat Rate Box",
        LFRB: "Large Flat Rate Box",
        PFRENV: "Flat Rate Padded Envelope",
        LGLFRENV: "Flat Rate Legal Envelope",
        MLFRB: 'Military Large Flat Rate Box'
      };
      let status = "label_status.exception";
      let tracking_id = {
        target:
          `https://tools.usps.com/go/TrackConfirmAction?tLabels=${order.label_tracking_id}`,
        id: order.label_tracking_id,
      };
      switch (this.orderType.id) {
        case 4: // voided
          status = `refund_status.${order.label_refund_status}`;
          break;
        case 5:
          tracking_id = {
            target:
              `https://tools.usps.com/go/TrackConfirmAction?tLabels=${order.label_return_tracking_id}`,
            id: order.label_return_tracking_id,
          };
          if (order.label_status_return) {
            status = `status_return.${order.label_status_return}`;
          } else {
            status = `status_return.${order.label_shipped_status}`;
          }
          break;
        default: // shipped
          status = `label_status.${order.label_shipped_status}`;
      }

      // all about ORIGIN
      let origin_name = `${order.origin_first_name || ""} ${
        order.origin_last_name || ""
      }`;
      let origin_company = order.origin_company;
      let origin_address = "";

      if (origin_company && origin_name.trim()) {
        origin_address = `${origin_company}, ${origin_name}`;
      } else if (origin_company) origin_address = origin_company;
      else origin_address = origin_name;

      if (order.origin_json) {
        const parsedOriginJSON = JSON.parse(order.origin_json);
        origin_name = `${parsedOriginJSON.first_name || ''} ${parsedOriginJSON.last_name || ''}`;
        origin_company = parsedOriginJSON.company;

        if (origin_company && origin_name.trim()) origin_address = `${origin_company}, ${origin_name}`;
        else if (origin_company) origin_address = origin_company;
        else origin_address = origin_name;
      }

      const pl = order.package_length;
      const pw = order.package_width;
      const ph = order.package_height;

      // Sometimes order.rate/order.total_price is returning a string so just to make sure convert to float
      const svg_logos = [
        "amazon",
        "big commerce",
        "ebay",
        "etsy",
        "facebook marketplace",
        "instagram",
        "paypal",
        "shopify",
        "walmart",
        "square",
        "squarespace",
        "wix",
        "woocommerce",
        "x-cart",
      ];

      const marketplaceWH = {
        ebay: { w: 55, h: 25 },
        etsy: { w: "auto", h: 30 },
        grandshipper: { w: 25, h: 30 },
        squarespace: { w: 27, h: 25 },
        whatnot: { w: 35, h: 20 },
        wix: { w: 42, h: 25 },
      };

      return {
        id: order.id,
        uid: order.user_id,
        marketplace: order.marketplace_id
          ? {
            img: svg_logos.includes(order.marketplace_code)
              ? `/images/integrations/${order.marketplace_code}/logo.svg`
              : `/images/integrations/${order.marketplace_code}/table-icon.png`,
            id: order.marketplace_id,
            name: order.marketplace_name,
            height: marketplaceWH[order.marketplace_code]
              ? marketplaceWH[order.marketplace_code].h
              : 25,
            weight: marketplaceWH[order.marketplace_code]
              ? marketplaceWH[order.marketplace_code].w
              : "auto",
          }
          : null,
        origin_postal: order.origin_id ? order.origin_postal_origin : "",
        order_number: order.order_number,
        ref_id: order.ref_id,
        description: order.description,
        created_at: order.created_at,
        // updated_at: order.updated_at,
        // shipped_at: order.shipped_at,
        name: {
          name: `${order.shipping_address_first_name || ""} ${
            order.shipping_address_last_name || ""
          }`,
          company: order.shipping_address_company || "",
        },
        address: {
          address1: `${order.shipping_address_address} ${
            order.shipping_address_address2 || ""
          }`,
          address2:
            `${order.shipping_address_city} ${order.shipping_address_province}`,
          address3:
            `${order.shipping_address_country} ${order.shipping_address_postal_code}`,
        },
        shipping_service: order.shipping_service_name,
        package_type: order.package_type ? pkgtypes[order.package_type] : "",
        confirmation: order.confirmation,
        total_weight: order.total_weight,
        dimension: (pw && pl && ph)
          ? `${order.package_length} x ${order.package_width} x ${order.package_height}`
          : "N/A",
        rate: parseFloat(order.rate),
        tracking_price: parseFloat(order.tracking_price),
        insurance_price: parseFloat(order.insurance_price),
        declared_value: parseFloat(order.declared_value),
        total_price: parseFloat(order.total_price),
        label_sticky: order.label_sticky,
        label_sticky_2: order.label_sticky_2,
        email: order.shipping_address_email,
        phone: order.shipping_address_phone,
        postmark_date: order.future_shipping_date,
        label_return_status: order.label_return_status,
        origin_address,
        tracking_id,
        status,
        printed_by: order.printed_by,
        returned_by: order.returned_by,
        voided_by: order.voided_by,
        product_sku: order.product_sku,
        acceptance_date: order.label_acceptance_date,
        delivered_date: order.label_delivered_date,
        label_claimed: order.label_claimed,
        acct_id: order.acct_id,
        delivery_zone: order.delivery_zone,
        extra_1: order.extra_1,
        extra_2: order.extra_2,
        extra_3: order.extra_3,
        extra_4: order.extra_4,
        extra_5: order.extra_5,
        shipsurance_id: order.shipsurance_id,
        shipsurance_claim: order.shipsurance_claim,
        marketplace_json: order.marketplace_json
          ? JSON.parse(order.marketplace_json)
          : null,
        prepaid_return: order.prepaid_return,
        final_cost: order.final_cost,
        verified_weight: order.verified_weight,
        surcharge: order.surcharge,
      };
    }, // DATA

    // EXPORT
    async exportOrders(
      exportType = "csv",
      title = "Export Data",
      returns = false,
    ) {
      try {
        const msg =
          "The current date range and active columns will be exported into a CSV file";
        if (!Cookies.get(hash(msg))) {
          const dialog = await this.$dialog.confirm({ title: title, body: msg }, {
            remember: true,
            view: "print",
            customClass: "print-dialog",
            proceed: "Export",
          });
          dialog.close();
        }

        const url = "/orders/export-vgt";
        const headings = this.columns.map((column) => {
          if (
            this.selectedColumns.includes(column.field) && column.field !== "id"
          ) {
            if(column.field === 'created_at'){
              return { [column.field]: "Printed Date (EST/EDT)" };
            }
            return { [column.field]: column.label };
          }
        }).filter((v) => !!v);
        const data = {
          headings,
          type: exportType,
          dateNow: moment().format("MMDDYYYY"),
        };

        const response = await axios.post(url, data, {
          params: Object.assign(
            {},
            { status: this.orderType.id },
            this.serverParams,
          ),
        });
        // console.log('export response', response);
        window.open(response.data.url);
      } catch (e) {
        console.log(e);
      }
    }, // EXPORT

    // MARKETPLACE OPTIONS
    async getMarketPlaces() {
      const mOptions = sessionStorage.getItem("marketplace_options");
      if (mOptions) {
        this.marketplaceOptions = JSON.parse(mOptions);
      } else {
        console.log("getting marketplace options");
        const { data } = await axios.get("/marketplaces-vgt");
        console.log("marketplaces", data);
        const marketplaces = data.map((m) => {
          const text = `<u>${m.name}</u>`;
          return {
            value: m.id,
            text,
          };
        });

        const options = [{ value: "all", text: "All" }, ...marketplaces];
        console.log("options", options);
        sessionStorage.setItem("marketplace_options", JSON.stringify(options));
        this.marketplaceOptions = options;
      }
    }, // MARKETPLACE OPTIONS

    // USER | PRINTED BY OPTIONS
    async getUserPrintedBy() {
      const uOptions = sessionStorage.getItem("user_options");
      if (uOptions) {
        this.userOptions = JSON.parse(uOptions);
      } else {
        const employess = this.user.employees.map((e) => {
          return {
            value: e.name,
            text: e.name,
          };
        });
        const options = [{ value: "all", text: "All" }, {
          value: "Admin",
          text: "Admin",
        }, ...employess];
        sessionStorage.setItem("user_options", JSON.stringify(options));
        this.userOptions = options;
      }

      const _options = this.userOptions.map((v) => v.value);
      let e_name = this.employee_name;
      // if (!e_name) e_name = 'Admin' // if admin select 'all'
      if (_options.includes(e_name)) {
        switch (this.orderType.name) {
          case "shipped":
            this.serverParams.printed_by = e_name;
            break;
          case "return":
            this.serverParams.returned_by = e_name;
            break;
          case "voided":
            this.serverParams.voided_by = e_name;
            break;
        }
      }
    }, // USER | PRINTED BY OPTIONS

    // SESSION
    async clearSessionAndFetch(sessName = "shipped") {
      try {
        console.log("clearing session");
        sessionStorage.removeItem(sessName);
        this.updateVGTParams({
          page: 1,
        });
        await this.fetchOrders();
      } catch (e) {
        console.error(e);
      }
    },
    async saveToSession(pageNumber, orders, sesName = "shipped") {
      try {
        console.log("setting session");
        let oldData = sessionStorage.getItem(sesName);
        oldData = oldData ? JSON.parse(oldData) : {};
        const newData = Object.assign({}, oldData, { [pageNumber]: orders });
        sessionStorage.setItem(sesName, JSON.stringify(newData));
        return true;
      } catch (e) {
        console.error(e);
      }
    },
    async getFromSession(pageNumber, sesName = "shipped") {
      try {
        console.log("getting session");
        const shippedData = sessionStorage.getItem(sesName);
        // no data in session yet
        if (shippedData === null) return null;

        const newData = JSON.parse(shippedData);
        return newData[pageNumber] || null;
      } catch (e) {
        console.error(e);
      }
    }, // SESSION

    // MODALS
    showOrder: async function (orderId) {
      try {
        this.isLoading = true;
        const { data } = await axios.get("/orders/" + orderId);

        data.rate_components = data.rate_components.map((r) => {
          // if (r.name == 'PB Parcel Protection Insurance') return
          if (r.type == "ins" && !r.value) return;
          return r;
        }).filter((r) => !!r);

        this.shown = data;

        // const keys = Object.keys(this.shownObjs);
        // if(keys.indexOf(`${orderId}`) < 0) {
        //   // this.isLoading = true;
        //   const { data } = await axios.get("/orders/" + orderId);
        //   this.shownObjs = Object.assign({}, this.shownObjs, {[orderId]: data});
        //   this.shown = data;
        //   // this.isLoading = false;
        // }else {
        //   this.shown = this.shownObjs[orderId];
        // }

        // wait for the next event cycle before showing modal
        await this.$nextTick();
        this.isLoading = false;
        this.$refs.viewOrderModal.show();
      } catch (e) {
        console.log("view order modal error: ", e.message);
      }
    },
    onShowOrderHide: async function () {
      console.log("closing modal");
      this.shown = null;
    },
    getWeight(weight) {
      if (weight) {
        return {
          lb: Math.floor(weight / 16),
          oz: Math.round(weight % 16),
        };
      }
      return { lb: 0, oz: 0 };
    },
    copyTrackingID(id) {
      this.$root.$emit("bv::hide::popover", `popover-${id}`);
      this.copyToClipboard(id);
      this.$emit("alert", {
        message: "Tracking Number successfully copied to clipboard",
        type: "success",
      });
    },
    copyToClipboard(textToCopy) {
      // navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
      } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          // here the magic happens
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    customSelectedRows() {
      if (this.customRange) {
        for (let i = 0; i < this.rows.length; i++) {
          this.$set(this.rows[i], "vgtSelected", false);
        }

        const subtractTo = (this.serverParams.page - 1) *
          this.serverParams.perPage;
        let parseRange = [], start, end;

        this.customRange.split(",").forEach((i) => {
          if (i.indexOf("-") > 0) {
            [start, end] = i.split("-").map(Number);
            if (start <= this.totalRecords && start < end) {
              if (end > this.totalRecords) {
                end = (this.serverParams.page || 1) * this.serverParams.perPage;
              }
              _.range(start, end + 1).forEach((i) => {
                i = subtractTo > 0 ? i - subtractTo : i;
                parseRange.push(i);
              });
            }
          } else {
            i = parseInt(i);
            if (i <= this.totalRecords) {
              i = subtractTo > 0 ? i - subtractTo : i;
              parseRange.push(i);
            }
          }
        });

        _.uniq(parseRange).forEach((i) => {
          if (this.rows[i - 1]) {
            this.$set(this.rows[i - 1], "vgtSelected", true);
          }
        });
      }
    },
    getSignatureName(data) {
      switch (data.confirmation) {
        case "DelCon":
          return "Delivery Confirmation";
        case "Sig":
          return "Signature";
        case "ADSIG":
          return "Adult Signature";
        case "ADSIGRD":
          return "Adult Signature with Restricted Delivery";
        case null:
          if (data.shipping_service_code == "EM") {
            return "Waiver of Signature";
          }
          return "Delivery Confirmation";
      }
    },
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/views/Orders/Mixins/VGTMixins.js